import React, { useState } from 'react';
import Box from "@material-ui/core/Box";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { enums } from "../../enums/enums";
import {
    LocationOnOutlined,
    BusinessCenterOutlined,
    VerifiedUserOutlined,
    AttachMoneyOutlined,
    PermIdentity,
    LocalAtmOutlined,
    EditOutlined,
    TurnedInOutlined,
    CheckCircleOutlined
} from '@material-ui/icons';
import IconButton from "@material-ui/core/IconButton";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { ICliente } from '../../entities/catalogos/ICliente';

import ConfirmDialog from '../controls/ConfirmDialog';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



export interface IStep {
    id: number
    nombre: string
    esUltimoPaso?: boolean
    tipo?: any
}

interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    cliente: ICliente
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
}

type Props = IStep & StateProps & DispatchProps

const Step = ({ id, nombre, solicitud, solicitudCopia, setSolicitud, setSolicitudCopia, esUltimoPaso = false, cliente }: Props) => {
    //estas propiedades se refieren a si el step esta completado o activo
    let activo = id === solicitud.seccionId;
    let completado = solicitud.estatusId >= id;
    const [showConfirmDialog, setConfirmDialog] = useState(false);

    // activar paso de proyecto
    if ((!cliente.clienteCreditoProyecto || (cliente.clienteCreditoProyecto.length == 1 && cliente.clienteCreditoProyecto[0].clienteCreditoProyectoID == 0)) && id === 2 && solicitud.seccionId == 1) {
        activo = true;
    }
    if (id === 0) {
        activo = false;
        completado = false;
    }
    if (id === 1 && solicitud.completada && !solicitud.modificar) {
        activo = false;
        completado = false;
    }
    const estilos = activo ? "active" : completado ? "completed" : solicitud.seccionId == 8 && !solicitud.modificar ? "completed" : "pending";

    let icono = {
        [enums.estatusSolicitud.datosClienteInv]: <PermIdentity />,
        [enums.estatusSolicitud.proyecto]: <TurnedInOutlined />,
        [enums.estatusSolicitud.origenDestino]: <LocationOnOutlined />,
        [enums.estatusSolicitud.datosMercancia]: <BusinessCenterOutlined />,
        [enums.estatusSolicitud.serviciosAdicionales]: <VerifiedUserOutlined />,
        [enums.estatusSolicitud.datosCliente]: <PermIdentity />,
        [enums.estatusSolicitud.markup]: <AttachMoneyOutlined />,
        [enums.estatusSolicitud.cotizacion]: <LocalAtmOutlined />
    };

    const cambiarSeccion = () => {
        setConfirmDialog(true);
    };

    const handleConfirmar = () => {
        //El tipo de envío y la cotización comparten el mismo step (7), si ya se creo la cotización (estatusId >= 8)
        //se va hacía el resumen de la cotización, en caso contrario al tipo de envío, siempre y cuando se quiera ir al step 7.
        const seccionId = id === 6 && solicitud.estatusId >= enums.estatusCotizacion.cotizacion ? enums.estatusCotizacion.cotizacion: id;
        const nuevaCotizacion = new Solicitud({ ...solicitud, seccionId, tipoServicio: solicitudCopia.tipoServicio });
        setSolicitud(nuevaCotizacion);
        //Copia todos los valores de la solicitud a su copia para reestablecer los valores en el Resumen
        setSolicitudCopia(nuevaCotizacion);
        setConfirmDialog(false);
    };

    const handleClose = () => {
        setConfirmDialog(false);
    };

    const mostrarEditar = (): boolean => {
        return !activo && completado && !solicitud.enviada && (solicitud.id == 0 || !!solicitud.modificar);
    };

    return (<>
        <Box display="flex" flexDirection="column" alignItems="center" className={estilos}>

            {!activo && completado &&
                <Box display="flex" justifyContent="center" alignItems="center" className="complete">
                    <CheckCircleOutlined />
                </Box>
            }
            <Box display="flex" justifyContent="center" alignItems="center" className="oval">
                {icono[id]}
            </Box>

            <Box className="step-label" style={{ position: "relative" }}>
                <span style={{
                    position: "absolute",
                    width: mostrarEditar() ? "140px" : "120px",
                    textAlign: "center",
                    left: "-60px"
                }}>
                    {nombre}
                    {mostrarEditar() &&
                        <IconButton size="small" onClick={cambiarSeccion}>
                            <EditOutlined style={{ fontSize: 15 }} />
                        </IconButton>
                    }
                </span>
            </Box>
        </Box>

        {!esUltimoPaso &&
            <Grid item xs={1} className="step-container">
                <div className="circle" />
                <div className="circle" />
            </Grid>
        }
        {showConfirmDialog &&
        //¿Desea cambiar de sección sin guardar los cambios?
            <ConfirmDialog titulo={traducirLabel(333)} contenido={traducirMessage(23)} abierto={showConfirmDialog} confirmar={handleConfirmar} cerrar={handleClose}></ConfirmDialog>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia
});

const mapDispatchToProps = {
    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
};

export default connect(mapStateToProps, mapDispatchToProps)(Step);
